"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const CardRequirementComponent_vue_1 = require("./CardRequirementComponent.vue");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'CardRequirementsComponent',
    props: {
        requirements: {
            type: Array,
            required: true,
        },
    },
    components: {
        'card-requirement': CardRequirementComponent_vue_1.default,
    },
    computed: {
        getClasses() {
            const hasMax = this.requirements.some((req) => req.max);
            return hasMax ? 'card-requirements card-requirements-max' : 'card-requirements';
        },
        indentRight() {
            return [false, ...this.requirements.map((req) => (req.nextTo || false))];
        },
    },
});
